import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';

import { isFinishedSportMatch } from '../../betting/accessMatchDetails';
import { ESportsPeriodType, RecordOfMatchEntity } from '../../betting/betting-entities';
import { SportId } from '../../betting/constants';
import { getFinishedPeriod } from '../get-finished-period';
import { ESportsKeyPeriod } from './constants';

import dictionary from './ESports.dictionary.json';

export const ESportsPeriods = (
  sportId?: SportId,
  periods?: RecordOfMatchEntity['periods'],
) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isResults = pathname.includes('results');

  if (isResults || isFinishedSportMatch(sportId, periods)) {
    return getFinishedPeriod(ESportsKeyPeriod.FINISHED, t);
  }

  const mapNumber = periods?.get(ESportsPeriodType.MAP, null)?.number || 0;

  return {
    key: ESportsKeyPeriod.PERIOD,
    value: t(dictionary.periodMap, { mapNumber }),
  };
};
